import { Modal, Button, Image } from 'antd'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ViewContainer from './container'

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    padding: 0;
  }

  .ant-modal-body {
    padding: 30px;
    text-align: center;
  }

  .ant-modal-footer {
    display: none;
  }
`

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const Title = styled.h2`
  color: #8b4513;
  font-size: 40px !important;
  font-weight: bold;
  margin-bottom: 16px;
`

const Description = styled.p`
  color: #121315;
  font-size: 18px;
  margin-bottom: 24px;
  max-width: 320px;
  text-align: center;
  margin-bottom: 20px !important;
`

const DoneButton = styled(Button)`
  width: 100%;
  height: 48px;
  background-color: #ffa500;
  border-color: #ffa500;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;

  &:hover, &:focus {
    background-color: #ff9000;
    border-color: #ff9000;
  }
`

export default function AccountDeactivated({ visible, setVisible }) {
  const handleClose = () => {
    setVisible(false)
  }

  return (
    <ViewContainer>
      {() => (
        <StyledModal
          visible={visible}
          onCancel={handleClose}
          footer={null}
          centered
          closable
          width={511}
        >
          <ModalContent>
            <Title>Account Deactivated</Title>
            <Image src="/images/auth-assets/dash.png" preview={false} style={{ marginBottom: '20px' }} />
            <Description>
              Your account has been deactivated due to inactivity. To continue, please create a new account. For Assistance, you may contact us at {' '}
              <a href="mailto:info@periperichecken.ph">info@periperichecken.ph</a>
            </Description>

            <DoneButton type="primary" onClick={handleClose}>
              Okay
            </DoneButton>
          </ModalContent>
        </StyledModal>
      )}
    </ViewContainer>
  )
}

AccountDeactivated.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired
}
